import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import { Box, ButtonProps } from "@chakra-ui/react";
import { ReactNode } from "react";
import { Link as RouterLink } from "react-router";

import { RanaButton } from "@nens/ranalib";

export interface BackButtonProps extends ButtonProps {
  back?: () => void;
  to?: string;
  isForward?: boolean;
  children?: ReactNode;
}

export const BackButton = ({ back, to, children, isForward, ...rest }: BackButtonProps) => {
  return (
    <RanaButton
      h="button"
      w="button"
      minW="fit"
      variant="fourthiary"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...(isForward ? { rightIcon: <ArrowForwardIcon /> } : { leftIcon: <ArrowBackIcon /> })}
      {...(to ? { as: RouterLink, to } : { onClick: back })}
      {...rest}
    >
      <Box as="span" textDecoration="none" _hover={{ textDecoration: "underline" }}>
        {children}
      </Box>
    </RanaButton>
  );
};
